<template>
  <div class="pic-img container">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- 渲染内容 -->
      <swiper-slide v-for="(k, index) of data" :key="index">
        <!-- <a :href="item.url" target="_blank" style="display:block;width:100%;height:100%">
          <img :src="isMobile?item.m_img:item.pc_img" alt="" style="vertical-align:middle">
        </a> -->
        <com-speakers :speakers="data[index]"></com-speakers>
      </swiper-slide>
      <!-- 轮播小圆点 -->
      <div class="swiper-pagination" slot="pagination" v-if="items.length>5"></div>
    </swiper>
    <!-- <div class="swiper-button-prev" slot="button-prev" v-if="items.length>5"></div>
    <div class="swiper-button-next" slot="button-next" v-if="items.length>5"></div> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ComSpeakers from 'gkConUI/com-speakers'

export default {
  components: {
    swiper,
    swiperSlide,
    ComSpeakers
  },
  props: ['items'],
  data () {
    return {
      swiperOption: {
        effect: 'slide',
        loop: false,
        autoplay: false,
        speed: 1000,
        fade: {
          crossFade: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // prevButton: '.swiper-button-prev',
        // nextButton: '.swiper-button-next',
        // paginationClickable: true,
        autoplayDisableOnInteraction: false
      }
    }
  },
  created () {},
  // 定义这个swiper对象
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    data () {
      let data = {}
      let idx = 0
      let start = 0
      let end = this.items.length
      if (end > 5) {
        for (var i = 0; i < Math.floor(end / 5); i++) {
          data[idx++] = this.items.slice(start, start + 5)
          start += 5
        }
        if (start < end) data[idx++] = this.items.slice(start, end)
      } else {
        data[idx++] = this.items.slice(start, end)
      }
      return data
    }
  },
  mounted () {
    // if (this.items.length <= 5) {
    //   this.swiper.destroy(false)
    // }
  },
  methods: {},
  beforeDestroy () {},
  watch: {}
}
</script>
<style lang="sass" scoped>
@import '~swiper/dist/css/swiper.css'

.pic-img
  position: relative
  margin-top: -1.5rem

  .swiper-container
    padding-bottom: 70px
    .swiper-wrapper
      .swiper-pagination-bullet-active
        background: red!important
      &:after
        content: 'aaaaaa'

  .swiper-button-next
      right: -50px
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23018231'%2F%3E%3C%2Fsvg%3E")
      cursor: pointer

  .swiper-button-prev
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23018231'%2F%3E%3C%2Fsvg%3E")
      left: -50px
      cursor: pointer

</style>
